import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Layout } from '~/components/UI';
import { LoadingTopBar } from '~/components/UI/LoadingTopBar';
import { CACHE_ACTIONS } from '~/constants/cache-actions.constants';
import { Honoraries } from '~/containers/Honoraries';
import { loadHonoraries } from '~/containers/Honoraries/actions';
import { LocalCacheHandler } from '~/utils/local-cache-handler';
import usePersistedFilters from '~/_shared/hooks/usePersistedFilters';
import {
  HONORARIES_FILTERS_KEY,
  getDefaultHonorariesFilters,
  getHonorariesYear,
  usesHonorariesCache,
} from '~/containers/Honoraries/helpers';

export const ScreensHonoraries = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const [isLoading, setIsLoading] = useState(true);

  // Filters kept across refreshes for a few minutes (per tenant/user/page).
  const persisted = usePersistedFilters(HONORARIES_FILTERS_KEY, getDefaultHonorariesFilters);
  const yearFilter = getHonorariesYear(persisted.filters);

  // Loads the restored (or current) year on mount, and again when it changes.
  useEffect(() => {
    loadData();
  }, [yearFilter]);

  async function loadData() {
    // The IndexedDB cache only ever holds the current year.
    const usesCache = usesHonorariesCache(persisted.filters, persisted.defaults);

    try {
      setIsLoading(true);

      if (usesCache) {
        await LocalCacheHandler.load({
          actionName: CACHE_ACTIONS.honoraries,
          dispatch,
          pathname,
        });
      }

      const { payload } = await dispatch(
        loadHonoraries({
          showLoading: false,
          year: yearFilter,
        })
      );

      if (usesCache) {
        await LocalCacheHandler.save({
          pathname,
          data: payload.data.customers,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <LoadingTopBar isActive={isLoading} />
      <Layout>
        <Honoraries persisted={persisted} />
      </Layout>
    </div>
  );
};
